import React from "react";
import styled from "styled-components";


export default styled.div`
    border-left: 1px solid lightgray;
    padding-left: 20px;
    flex: 1 0 auto;

    @media(max-width: 1400px) {
        flex-basis: calc(100% - 68px);
    }

    @media(max-width: 725px) {
        flex-basis: 100%;
        border: none;
        padding: 0;
    }
`;
